import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { STRINGS } from "../Strings";
import { FiArrowRight } from "react-icons/fi";
import { 
    LuHeartHandshake, LuActivity, LuBrainCircuit, LuSprout, 
    LuUsers, LuShieldAlert, LuLeaf, LuDoorOpen 
} from "react-icons/lu";

// Picha zote mbili zinaitwa hapa kwenye JSX pekee
import bgOuterSection from '../assets/banner3.jpg';
import bgInnerContent from '../assets/banner4.jpg';

export default function HomeServices(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "sw";
    const s = STRINGS.homeServices;

    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Space for initialization
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    // Ramani ya Icon kwa kila huduma (1 hadi 8)
    const getServiceIcon = (index) => {
        const icons = [
            <LuHeartHandshake size={22} />,
            <LuActivity size={22} />,
            <LuBrainCircuit size={22} />,
            <LuSprout size={22} />,
            <LuUsers size={22} />,
            <LuShieldAlert size={22} />,
            <LuLeaf size={22} />,
            <LuDoorOpen size={22} />
        ];
        return icons[index] || <LuHeartHandshake size={22} />;
    };

    if (ready) {
        return (
            <div 
                className="MainBodySection services-outer-canvas position-relative"
                style={{ backgroundImage: `url(${bgOuterSection})` }}
            >
                {/* Primary Color Overlay (Opacity ya chini) */}
                <div className="outer-primary-overlay"></div>

                <div className="container position-relative z-index-2">
                    
                    {/* Upper Section Header */}
                    <div className="text-center mb-5">
                        <span className="services-kicker text-uppercase font-semi-bold">
                            {s.topTag[language]}
                        </span>
                        <h2 className="title-font-bold text-white services-main-heading mt-2">
                            {s.heading[language]}
                        </h2>
                    </div>

                    {/* Middle Section: The Rectangular Masterpiece Box */}
                    <div 
                        className="services-inner-rectangle mx-auto position-relative shadow-4"
                        style={{ backgroundImage: `url(${bgInnerContent})` }}
                    >
                        {/* Secondary Color Overlay */}
                        <div className="inner-secondary-overlay"></div>

                        {/* Content Layer */}
                        <div className="inner-content-wrapper position-relative z-index-3">
                            <div className="row g-4">
                                {s.items.map((item, idx) => (
                                    <div className="col-12 col-md-6 col-lg-3" key={idx}>
                                        <div className="premium-service-micro-card">
                                            <div className="service-icon-bubble mb-3">
                                                {getServiceIcon(idx)}
                                            </div>
                                            <h4 className="title-font-semi-bold text-dark service-card-title mb-2">
                                                {item.title[language]}
                                            </h4>
                                            <p className="font-regular text-dark-50 service-card-desc mb-0">
                                                {item.highlight[language]}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Action Row inside the rectangle */}
                            <div className="text-center mt-5 pt-3 border-top-glow">
                                <button 
                                    className="btn btn-services-action title-font-semi-bold d-inline-flex align-items-center gap-2"
                                    onClick={() => appContext.navTo({ item: 'services' })}
                                >
                                    <span>{s.buttonText[language]}</span>
                                    <FiArrowRight size={16} />
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "500px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}